export class UserInfo {
    constructor() {
        /**
         * Gets or sets the user display name
         */
        this.name = '';
        /**
         * Gets or sets the user email
         */
        this.email = '';
    }
}
//# sourceMappingURL=user-info.js.map